<template>
    <v-dialog v-model="deleteModal" width="500">
        <v-card>
            <v-card-title> Delete Image</v-card-title>

            <v-card-text>
                <p>
                    You are about to delete <b>{{ deleteFilename }}</b>. This will remove the image from any
                    fields where it is in use. If a user has selected this image, their selection will revert to the field's default selection.
                </p>
                <p>Continue?</p>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="closeDeleteModal(false)">
                    Cancel
                </v-btn>
                <v-btn color="primary" @click="destroy()">
                    Delete Image
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import MediaCrudMixin from '@/views/Admin/MediaLibrary/MediaCrudMixin';
import { mapActions, mapMutations, mapState } from 'vuex';
import store from '@/store/store';

export default {
    mixins: [ MediaCrudMixin ],

    computed: {
        ...mapState('mediaLibrary', ['mediaId']),

        deleteFilename: {
            get: function() {
                return store.state.mediaLibrary.deleteFilename;
            },
            set: function(value) {
                this.setDeleteFilename(value);
            }
        },

        deleteModal: {
            get: function() {
                return store.state.mediaLibrary.deleteModal;
            },
            set: function(value) {
                this.toggleDeleteModal(value);
            }
        },
    },

    methods: {
        ...mapMutations({
            toggleDeleteModal: 'mediaLibrary/toggleDeleteModal',
        }),

        ...mapActions({
            destroyData: 'mediaLibrary/destroyData'
        }),

        destroy() {
            this.destroyData();
            this.closeDeleteModal();
        },

        closeDeleteModal() {
            this.setMediaId('');
            this.setDeleteFilename('');
            this.toggleDeleteModal(false);
        }
    }
};
</script>
